module.exports = __webpack_public_path__ + "img/newicon9on.6b785d33.svg";